import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

// react query config
const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false
  }
}

const queryClient = new QueryClient({ defaultOptions: queryConfig })

const DataProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
    </QueryClientProvider>
  )
}

export default DataProvider
